module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vendor":"Vendor","allVendors":"All vendors"},"no":{"vendor":"Leverandør","allVendors":"Alle Leverandører"}}')
  delete Component.options._Ctor
}
